module.exports = __webpack_public_path__ + "static/img/1.1692cca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/zh/1.png
// module id = 9d0f
// module chunks = 0